export default {
    es: {
        '%s | Applications': '%s | Aplicaciones',
        '(firstname.lastname@solvia.es)': '(nombre.apellido@solvia.es)',
        '1 year': '1 año',
        '3 months': '3 meses',
        '6 months': '6 meses',
        'A new code has been sent to your email address.': 'Se ha enviado un nuevo código a su dirección de correo electrónico.',
        'A password reset link will be emailed to you momentarily.': 'En breve recibirás un email con un enlace para restablecer tu contraseña.',
        'ACS URL': 'URL de ACS',
        'ACTIVE': 'Activo',
        'AD Group': 'Grupo AD',
        'AD Status': 'Estado en AD',
        'Access origin': 'Origen del acceso',
        'Acting As': 'Secr. de',
        'Action': 'Acción',
        'Activate Two-Factor Auth': 'Activar autenticación en dos pasos',
        'Activate': 'Activar',
        'Active (user status)': 'Alta',
        'Active at AD': 'Alta en AD',
        'Active users to whom you have access': 'Usuarios activos a los que tienes acceso',
        'Active': 'Activo',
        'Add Profile': 'Añadir perfil',
        'Add Role': 'Añadir rol',
        'Address': 'Dirección',
        'Alias': 'Alias',
        'All Users': 'Todos los usuarios',
        'All': 'Todos',
        'Alternative Email': 'Email alternativo',
        'Alternative email': 'Email alternativo',
        'An error has occurred': 'Ha ocurrido un error.',
        'An error occurred while sending the email.': 'Se produjo un error al enviar el correo electrónico.',
        'App environment': 'Entorno de la aplicación',
        'Application Username': 'Usuario aplicación',
        'Application list': 'Lista de aplicaciones',
        'Application that manages identity': 'Aplicación que gestiona la identidad',
        'Application user': 'Usuario de aplicación',
        'Application': 'Aplicación',
        'Applications': 'Aplicaciones',
        'Approve profile': 'Aprobar perfil',
        'Approve profile?': 'Aprobar el perfil?',
        'Apps assigned': 'Aplicaciones asignadas',
        'Are you sure you want to generate a new password for this user?': '¿Está seguro de que desea generar una nueva contraseña a este usuario?',
        'Are you sure you want to reset the Two-Factor Authentication?': '¿Está seguro de que desea restablecer la autenticación en dos pasos? El codigo actual dejara de funcionar.',
        'Array Update': 'Edición en matriz',
        'Assignment': 'Asignación',
        'Attributes': 'Atributos',
        'Audit': 'Auditoría',
        'Authentication type': 'Tipo de autenticación',
        'Authentication': 'Autenticación',
        'Authorization Date': 'Fecha de la autorización',
        'Authorization Type': 'Tipo de autorización',
        'Authorized By': 'Authorizado por',
        'Automatically Assigned': 'Asignado automáticamente',
        'Avatar': 'Avatar',
        'BCC': 'CCO',
        'Back to home': 'Volver al inicio',
        'Bad Request': 'Petición incorrecta',
        'Blocked (user status)': 'Bloqueo',
        'CC': 'CC',
        'Can update/verify OTP seed': 'Puede actualizar/verificar semilla OTP',
        'Category': 'Categoría',
        'Certificate': 'Certificado',
        'Change Password': 'Cambiar contraseña',
        'Change Status': 'Cambiar estado',
        'Change type': 'Tipo de cambio',
        'Change your password': 'Cambia tu contraseña',
        'Changes Not Applied': 'Cambios sin aplicar',
        'Changes audit': 'Auditoría de cambios',
        'Changes to the fields name, surname, email of Office 365 users will be overwritten by the active directory data at each login.': 'Los cambios en los campos nombre, apellidos, email de los usuarios de Office 365 serán sobrescritos por los datos del directorio activo en cada inicio de sesión.',
        'Changes to the fields name, surname, email of local users must be edited in the corresponding section.': 'Los cambios en los campos nombre, apellidos, email de los usuarios locales deben editarse en la sección correspondiente.',
        'Check password empty or not equeals.': 'Comprueba que la contraseña no esté vacía o sean iguales.',
        'City': 'Ciudad',
        'Clear Signature': 'Limpiar firma',
        'Client': 'Cliente',
        'Clone profiles': 'Clonar perfiles',
        'Clone user': 'Clonar usuario',
        'Clone user?': 'Clonar usuario?',
        'Comments': 'Comentarios',
        'Companies': 'Empresas',
        'Company list': 'Lista de compañias',
        'Company': 'Empresa',
        'Completed percentage': 'Porcentaje completado',
        'Confirm': 'Confirmar',
        'Contact Telephone': 'Teléfono de contacto',
        'Content of email': 'Contenido del email',
        'Continue': 'Continuar',
        'Copy of %s': 'Copia de %s',
        'Country': 'País',
        'Created At': 'Alta',
        'Created By User': 'Creado por',
        'DISABLED': 'Desactivado',
        'Dashboard': 'Dashboard',
        'Date': 'Fecha',
        'Force 2FA configuration': 'Forzar configuración 2FA',
        'Default Team Role': 'Rol por defecto del equipo',
        'Default': 'Por defecto',
        'Delegated identity application': 'Aplicación de identidad delegada',
        'Delete %s?': '¿Eliminar %s?',
        'Delete': 'Eliminar',
        'Deleted At': 'Baja',
        'Department list': 'Lista de departamentos',
        'Department': 'Departamento',
        'Departments': 'Departamentos',
        'Description': 'Descripción',
        'Digits in base 10, 0 through 9.': 'Dígitos en base 10, de 0 a 9.',
        'Disable': 'Desactivar',
        'Discharged (user status)': 'Baja',
        'Discharged at AD': 'Baja en AD',
        'Display In Home Page': 'Mostrar en página principal',
        'Do Access': 'Acceder',
        'Do Discharge': 'Dar de baja',
        'Do Discharge?': '¿Dar de baja?',
        'Do Login': 'Iniciar sesión',
        'Do Restore': 'Restaurar',
        'Do Restore?': '¿Restaurar?',
        'Do force 2FA configuration?': '¿Quieres forzar la configuración 2FA?',
        'Document Type': 'Tipo de documento',
        'Document list': 'Lista de documentos',
        'Document': 'Documento',
        'Download template': 'Descargar plantilla',
        'Download': 'Descargar',
        'Duplicate': 'Duplicar',
        'Edit %s': 'Editar %s',
        'Edit Contact Information': 'Editar información de contacto',
        'Edit profiles': 'Editar perfiles',
        'Edit': 'Editar',
        'Email content': 'Contenido del email',
        'Email sent': 'Email enviado',
        'Email the user to reset their password?': '¿Enviar un email al usuario para restablecer su contraseña?',
        'Email': 'Email',
        'Employee Number': 'Número de empleado',
        'End Date': 'Fecha de expiración',
        'Enable SAML2': 'Habilitar SAML2',
        'Enter the 6-digit code from Google Authenticator.': 'Introduce el código de 6 dígitos de Google Authenticator.',
        'Entity ID': 'ID de entidad',
        'Error while saving': 'Error al guardar',
        'Exceptions': 'Excepciones',
        'Exclude when duplicating profiles': 'Excluir al duplicar perfiles',
        'Exit without saving? Changes will be lost.': '¿Salir sin guardar? Se perderán los cambios.',
        'Expiration Date': 'Fecha de caducidad',
        'Expiration date from': 'Fecha de caducidad desde',
        'Expiration date is required if any profile is marked to expire.': 'La fecha de caducidad es obligatoria si algún perfil está marcado para caducar.',
        'Expiration date should not be set if no profile is marked to expire.': 'La fecha de caducidad no debería establecerse si ningún perfil está marcado para caducar.',
        'Expiration date to': 'Fecha de caducidad hasta',
        'Expiration date': 'Fecha de caducidad',
        'Expiration deadline': 'Fecha de caducidad',
        'Expiration': 'Caducidad',
        'Expire': 'Caducar',
        'Export permissions Excel': 'Exportar permisos Excel',
        'Export permissions Json': 'Exportar permisos Json',
        'Export profiles Excel': 'Exportar perfiles Excel',
        'Export profiles Json': 'Exportar perfiles Json',
        'Extension': 'Extensión',
        'Failure to change password.': 'Fallo al cambiar la contraseña.',
        'Field/Application': 'Campo/Aplicación',
        'Finish date created': 'Fecha de finalización creación',
        'Finish date': 'Fecha final',
        'First Name': 'Nombre',
        'Forgot your password?': '¿Olvidaste tu contraseña?',
        'Form': 'Formulario',
        'From: ': 'Desde: ',
        'Go Back': 'Volver',
        'Good Bye!': '¡Hasta pronto!',
        'Has Expiration Date': 'Tiene fecha de caducidad',
        'Hidden ext. tlf': 'Ocultar ext. y tlf.',
        'Hide variables': 'Ocultar variables',
        'I don\'t have access to my app, send me a code by email.': 'No tengo acceso a mi aplicación, envíame un código por email.',
        'Hide expiration': 'Ocultar caducidad',
        'IMPORT_LIVE_HELP_HTML': 'Importar de forma síncrona (puede bloquear la web temporalmente). En caso contrario, la tarea de importación podrá tardar hasta %s minuto(s) en comenzar.',
        'IMPORT_PROFILE_ROLES_NOTE': '¿Está seguro de que desea importar los perfiles de roles?',
        'IP': 'IP',
        'Id': 'Id',
        'Identifier': 'Identificador',
        'Identity': 'Identidad',
        'If the user is registered on the site, he or she will receive and email with a link to reset the account password.': 'Si el usuario está registrado en el sitio, recibirá un email con un enlace para restablecer la contraseña de la cuenta.',
        'If you dont know your password please click': 'Si no recuerdas tu contraseña haz click',
        'If you think this is an error, please try again later or contact the system administrator.': 'Si cree que se trata de un error, por favor, vuelve a intentarlo más tarde o comuníquese con el administrador de sistemas.',
        'Image': 'Imagen',
        'Import Permissions Json': 'Importar permisos Json',
        'Import Profile Roles': 'Importar perfiles de roles',
        'Import Profiles Json': 'Importar perfiles Json',
        'Import permissions Excel': 'Importar permisos Excel',
        'Import profiles Excel': 'Importar perfiles Excel',
        'Import': 'Importar',
        'In Name Of': 'Delegado/a',
        'In which position would you like to place it?': '¿En qué posición quieres situarlo?',
        'Inactive': 'Inactivo',
        'Initial date created': 'Fecha de inicio de creación',
        'Initial date': 'Fecha inicial',
        'Integrated With %s': 'Integrado con %s',
        'Integrated': 'Integrado',
        'Internal Server Error': 'Se produjo un error en las comunicaciones con el servidor.',
        'Invalid Document.': 'Documento inválido.',
        'Invalid JSON format for params': 'Formato JSON inválido para los parámetros',
        'Invalid Nif.': 'NIF inválido',
        'Invalid code': 'Código inválido',
        'Invalid username or password.': 'Usuario o contraseña incorrectos.',
        'Is Trainee': 'Es becario',
        'Is temporary contract': 'Es contrato temporal',
        'Is trainee': 'Es becario',
        'It seems there was a problem logging in. You may not have access to this application.': 'Parece que hubo un problema iniciando sesión. Es posible que no tenga acceso a esta aplicación.',
        'JSON File': 'Archivo JSON',
        'Keep on deactivating internal': 'Mantener al desactivar internos',
        'Keep on internal users disabled': 'Mantener en usuarios internos desactivados',
        'LOGIN_AS_NOTE': 'Al simular un usuario, se abrirá una nueva ventana del navegador con la sesión del usuario seleccionado. Si ya tiene una sesión iniciada, se cerrará y se abrirá la sesión del usuario.',
        'Language': 'Idioma',
        'Last Name': 'Apellidos',
        'Level': 'Nivel',
        'Limit to Application': 'Limitar a aplicación',
        'Limit to Profile': 'Limitar a perfil',
        'Local Users': 'Usuarios locales',
        'Local user list': 'Lista de usuarios locales',
        'Log In': 'Entrar',
        'Login As': 'Simular',
        'Login Error': 'Error de inicio de sesión',
        'Login audit': 'Logs de acceso',
        'Login': 'Login',
        'Logo Icon Url': 'URL de icono (PNG/ICO)',
        'Logo Light Png Url': 'URL de logo en PNG (light)',
        'Logo Png Url': 'URL de logo en PNG',
        'Logo Svg Url': 'URL de logo en SVG',
        'Logout': 'Cerrar sesión',
        'Long user': 'Usuario largo',
        'Lowercase letters a through z.': 'Letras minúsculas, de la a a la z.',
        'MISSING': 'Falta',
        'Main Info': 'Información principal',
        'Main Url': 'URL principal',
        'Menu Group': 'Agrupación (menú)',
        'Menu Subgroup': 'Agrupación (submenú)',
        'Mobile / Extension / Contact Tel.': 'Móvil / Extensión / Tel. contacto',
        'Mobile Phone': 'Móvil',
        'Movil / Extension': 'Móvil / Extensión',
        'Multiple profiles': 'Múltiples perfiles',
        'Must be 10 characters in length.': 'Como mínimo debe tener 10 caracteres de longitud.',
        'Must be composed of characters from at least three of the following category:': 'Debe estar compuesta por caracteres de al menos tres de las siguientes categorías:',
        'Must not contain proper names.': 'No debe contener nombres propios.',
        'Must not repeat any of the last 24 passwords used.': 'No se debe repetir ninguna de las últimas 24 contraseñas utilizadas.',
        'NIF': 'NIF',
        'Name ID Format': 'Formato de ID de nombre',
        'Name Of User': 'Nombre del usuario',
        'Name': 'Nombre',
        'New %s': 'Nuevo %s',
        'New password sent.': 'Nueva contraseña enviada.',
        'New value': 'Valor nuevo',
        'Nif': 'NIF',
        'Non-alphabetic characters (e.g. !, $, #, %).': 'Caracteres no alfabéticos (por ejemplo !, $, #, %).',
        'Not AD User': 'No esta el usuario en AD',
        'Not Created': 'No creado',
        'Not Found': 'No encontrado',
        'Note': 'Nota',
        'Notification Type List': 'Lista de tipos de notificaciones',
        'Oauth': 'Oauth',
        'Objective user name': 'Nombre del usuario objetivo',
        'Objective user': 'Usuario objetivo',
        'Of Group': 'Del grupo',
        'Office list': 'Lista de oficinas',
        'Office': 'Oficina',
        'Offices': 'Oficinas',
        'Old password': 'Contraseña antigua',
        'Old value': 'Valor antiguo',
        'Oops!': '¡Upss!',
        'Operation type': 'Tipo de operación',
        'Optional': 'Opcional',
        'Or enter the code below:': 'O introduce el código a continuación:',
        'Order in login': 'Orden al mostrar en login',
        'Order': 'Orden',
        'Origin Identifier': 'Identificador de usuario',
        'Origin user': 'Usuario de referencia',
        'Origin': 'Maestro',
        'PENDING': 'Pendiente',
        'Parameters': 'Parámetros',
        'Password Expiration Date': 'Fecha de caducidad de la contraseña',
        'Password change failed.': 'Error al cambiar la contraseña.',
        'Password changed successfully.': 'Contraseña cambiada correctamente.',
        'Password must be at least 10 characters long': 'La contraseña debe tener al menos 10 caracteres',
        'Password policy:': 'Política de contraseñas:',
        'Password was expired. You must change your password.': 'La contraseña ha caducado. Debe cambiar su contraseña.',
        'Password': 'Contraseña',
        'Passwords do not match': 'Las contraseñas no coinciden',
        'Pending Recertification': 'Recertificación pendiente',
        'Pending approval': 'Pendiente de aprobación',
        'Pending recertifications': 'Recertificaciones pendientes',
        'Pending update AD': 'Pendiente de actualización en AD',
        'Pending update on AD': 'Pendiente de actualización en AD',
        'Permission list': 'Lista de permisos',
        'Permission': 'Permiso',
        'Permissions could not be downloaded. Try again later.': 'Los permisos no pudieron ser descargados. Inténtelo de nuevo más tarde.',
        'Permissions': 'Permisos',
        'Please enter the verification code shown in your app.': 'Por favor, introduce el código de verificación que aparece en tu aplicación.',
        'Please fill the origin identifier.': 'Por favor, rellene el nombre de usuario.',
        'Portal': 'Portal',
        'Portfolio': 'Cartera',
        'Position': 'Ubicación fisica',
        'Postal Code': 'Código postal',
        'Profile List': 'Lista de perfiles',
        'Profile Type': 'Tipo de perfil',
        'Profile Types': 'Nivel de seguridad',
        'Profile name': 'Nombre del perfil',
        'Profile': 'Perfil',
        'Profiles assigned': 'Perfiles asignados',
        'Profiles could not be downloaded. Try again later.': 'Los perfiles no pudieron ser descargados. Inténtelo de nuevo más tarde.',
        'Profiles to be added': 'Perfiles a añadir',
        'Profiles to be deleted': 'Perfiles a eliminar',
        'Profiles': 'Perfiles',
        'Profiling': 'Perfilado',
        'Provider list': 'Lista de proveedores',
        'Provider': 'Proveedor',
        'Providers': 'Proveedores',
        'Province': 'Provincia',
        'Read Only': 'Solo lectura',
        'Recipients': 'Destinatarios',
        'Recover Password': 'Recuperar contraseña',
        'Redirect URI': 'URI de redirección',
        'Redirect URIs': 'URIs de redirección',
        'Redirect list': 'Lista de redirecciones',
        'Redirecting...': 'Redirigiendo...',
        'Regestry of changes': 'Registro de cambios',
        'Registry of Login': 'Registro de Login',
        'Registry of changes': 'Registro de cambios',
        'Registry of logins': 'Registro de logins',
        'Remove %s?': '¿Quitar %s?',
        'Remove': 'Quitar',
        'Remove?': '¿Quitar?',
        'Renewal': 'Renovación',
        'Repeat Password': 'Repetir contraseña',
        'Replaced By': 'Sustit.',
        'Reset Password': 'Restablecer contraseña',
        'Reset Two-Factor Auth': 'Restablecer autenticación en dos pasos',
        'Reset password': 'Restablecer contraseña',
        'Responsible User Username': 'Usuario responsable',
        'Responsible User': 'Usuario responsable',
        'Responsible': 'Resp.',
        'Result': 'Resultado',
        'Role list': 'Lista de roles',
        'Role': 'Rol',
        'Roles': 'Roles',
        'SAML2 Configuration': 'Configuración SAML2',
        'SLS URL': 'URL de SLS',
        'Saved': 'Guardado',
        'Saving...': 'Guardando...',
        'Scan this code with Google Authenticator': 'Escanea este código con Google Authenticator',
        'Schedule': 'Horario',
        'Search user': 'Buscar usuario',
        'See User Details': 'Ver detalles de usuario',
        'Select': 'Seleccionar',
        'Self-identity application': 'Aplicación de identidad propia',
        'Send Access Instructions': 'Enviar instrucciones de acceso',
        'Send New Password': 'Generar nueva contraseña y enviar',
        'Send': 'Enviar',
        'Sending ...': 'Enviando ...',
        'Set expirations': 'Establecer caducidades',
        'Short description': 'Descripción corta',
        'Short user': 'Usuario corto',
        'Show expiration': 'Mostrar caducidad',
        'Show in login': 'Mostrar en login',
        'Show variables': 'Mostrar variables',
        'Sign Inside (HTML)': 'Firma <small class="text-muted"><em>dentro del área marcada</em></small><sup>*</sup>',
        'Simulate': 'Simular',
        'Soon to expire': 'Próximo de caducar',
        'Source user': 'Usuario origen',
        'Start Date': 'Fecha de inicio',
        'Status': 'Estado',
        'Subcategory': 'Subcategoría',
        'Subject': 'Asunto',
        'Success': 'Éxito',
        'Svg': 'SVG',
        'Target user': 'Usuario destino',
        'Team': 'Equipo',
        'Telephone extension': 'Extensión teléfonica',
        'Telephone': 'Teléfono',
        'The code field is required.': 'El campo código es obligatorio.',
        'The code must be 6 digits.': 'El código debe tener 6 dígitos.',
        'The expires at field must be a date after yesterday.': 'La fecha de caducidad debe ser una fecha posterior a ayer.',
        'The expires at must be a date after yesterday.': 'La fecha de caducidad debe ser una fecha posterior a ayer.',
        'The file could not be processed.': 'El archivo no pudo ser procesado.',
        'The file is not a valid JSON file.': 'El archivo no es un archivo JSON válido.',
        'The password and repeat password must match.': 'La contraseña y la repetición de la contraseña deben coincidir.',
        'The password does not meet the minimum security requirements.': 'La contraseña no cumple con los requisitos mínimos de seguridad.',
        'The profile is already attached to the user.': 'El perfil ya está asignado al usuario.',
        'The reset password link is invalid or has expired.': 'El enlace para restablecer la contraseña es inválido o ha caducado.',
        'The trigger action id field is required.': 'El campo id de la acción del trigger es obligatorio.',
        'The trigger will fire when an user is created.': 'El trigger se disparará cuando se dé de alta un usuario.',
        'The trigger will fire when an user\'s profiles in the application {{application}} or its username are changed.': 'El trigger se disparará cuando se cambien los perfiles de un usuario en la aplicación {{application}} o su nombre de usuario.',
        'The trigger will fire when, in the application {{application}}, the profile {{profile}} is added to or removed from a user.': 'El trigger se disparará cuando se añada o se retire en la aplicación {{application}} el perfil {{profile}} a un usuario.',
        'The username must be at least 7 characters.': 'El nombre de usuario debe tener al menos 7 caracteres.',
        'This field is required': 'Este campo es obligatorio',
        'To: ': 'Hasta: ',
        'Token': 'Token',
        'Token version': 'Versión del token',
        'Too Many Requests': 'Demasiadas intentos erroneos',
        'Trainee': 'Becario',
        'Trigger': 'Trigger',
        'Triggers': 'Triggers',
        'Two-Factor Authentication': 'Autenticación en dos pasos',
        'Two-Step Activation': 'Activación en dos pasos',
        'Two-Step Verification': 'Verificación en dos pasos',
        'Type': 'Tipo',
        'Unique profile': 'Perfil único',
        'Unknown Status': 'Estado desconocido',
        'Unsaved changes': 'Cambios sin guardar',
        'Update User Application Username': 'Actualizar usuario aplicación',
        'Updated By User': 'Actualizado por',
        'Uppercase letters A to Z.': 'Letras mayúsculas, de la A a la Z.',
        'Uri': 'URL',
        'Url': 'URL',
        'User First Name': 'Nombre de usuario',
        'User Last Name': 'Apellidos de usuario',
        'User List': 'Lista de usuarios',
        'User Profile Replication': 'Añade perfiles en base a replicación de los perfiles de otro usuario',
        'User Profiles': 'Perfiles de usuario',
        'User Type': 'Tipo de usuario',
        'User already has this role': 'El usuario ya tiene este rol',
        'User has already assigned a role. This role will be deleted. Are you sure?': 'El usuario ya tiene asignado un rol. Este rol será eliminado. ¿Está seguro?',
        'User making the change': 'Usuario que realiza el cambio',
        'User profile grouped list': 'Lista agrupada de perfiles de usuario',
        'User': 'Usuario',
        'Username who made the change': 'Usuario que realizó el cambio',
        'Username': 'Nombre de usuario',
        'Users in your charge': 'Usuarios a tu cargo',
        'Users soon to expire': 'Usuarios próximos a caducar',
        'Users': 'Usuarios',
        'Variables': 'Variables',
        'View in {lang}': 'Ver en {lang}',
        'Webhook key': 'Clave del webhook',
        'Webhook url': 'URL del webhook',
        'You can close this window now.': 'Puedes cerrar esta ventana ahora.',
        'You can only have one profile for this application': 'Solo puedes tener un perfil para esta aplicación',
        'Your password has been changed successfully.': 'Tu contraseña ha sido cambiada correctamente.',
        'Your session has been closed.': 'Has cerrado sesión.',
        'auth code' : 'código de autenticación',
        'cif': 'NIF',
        'departments': 'departamentos',
        'downloaded-table': 'descarga',
        'here': 'aquí',
        'offices': 'Oficinas',
        'Origin identifier': 'Usuario corto',
        'Short name adsolvia': 'Nombre corto adsolvia',
        'Long name adsolvia': 'Nombre largo adsolvia',
        'Short name intrum': 'Nombre corto Intrum',
        'Long name intrum': 'Nombre largo Intrum',
        'The address lat field is required.': 'El campo latitud de la dirección es obligatorio.',
        'The address lng field is required.': 'El campo longitud de la dirección es obligatorio.',
    },
    en: {
        '**': '**',
        'ACTIVE': 'Active',
        'Active at AD': 'Active at AD',
        'DISABLED': 'Disabled',
        'Discharged at AD': 'Discharged at AD',
        'Do Access': 'Access',
        'Do Login': 'Login',
        'IMPORT_HELPER_HTML': 'Select or drag a CSV (separated by &quot;<b>;</b>&quot;) or XSLX file containing the following columns: %s',
        'IMPORT_LIVE_HELP_HTML': 'Import synchronously (may temporarily block the web). Otherwise, the import task may take up to %s minute(s) to start.',
        'LOGIN_AS_NOTE': 'When simulating a user, a new browser window will open with the session of the selected user. If you already have a session started, it will be closed and the user session will be opened.',
        'MISSING': 'Missing',
        'NIF': 'NIF',
        'Nif': 'NIF',
        'Not AD User': 'Not AD user',
        'PENDING': 'Pending',
        'Pending update AD': 'Pending update AD',
        'Show in login': 'Show in login',
        'Order': 'Order',
        'Source user': 'Source user',
        'Target user': 'Target user',
        'Clone profiles': 'Clone profiles',
    },
};